import CustomDialog from "../../common/CustomDialog";
import FormField from "../../common/FormField";
import CustomButton from "../../common/CustomButton";
import SelectField from "../../common/SelectField";
import FormCheckbox from "../../common/FormCheckbox";

export default function AddMerchantGroup({
    open,
    onHandleClose,
    formData,
    handleChange,
    handleSubmit,
    isSubmitting,
    formErrors,
    isEditing
}) {
    const fields = [
        { label: "Group Name", name: "groupName", type: "text" },
        { label: "Group Chat ID", name: "groupChatId", type: "text" },
        {
            label: "Group Type",
            name: "groupType",
            type: "select",
            options: [
                { value: "payin", label: "Pay In" },
                { value: "payout", label: "Pay Out" },
                { value: "payin,payout", label: "Both" }
            ]
        },
        { label: "Company Name", name: "companyName", type: "text" },
        { label: "Merchant MID", name: "mid", type: "text" },
        { label: "Created By", name: "createdBy", type: "text" },
        { label: "Active Group", name: "isActive", type: "checkbox" },
    ];

    // Handles pressing Enter to submit from any field
    const handleKeyDown = (e) => {
        try {
            if (e?.key === "Enter" && e?.target?.type !== "textarea") {
                e?.preventDefault();
                handleSubmit(e);
            }
        } catch (error) {
            console.log(`Error: ${error}`);
        }
    };

    const title = isEditing ? "Edit Merchant Group" : "Add Merchant Group";
    const visibleFields = isEditing
        ? fields.filter(f => !["createdBy"].includes(f.name))
        : fields;

    return (
        <>
            <CustomDialog
                open={open}
                onClose={onHandleClose}
                title={title}
                actions={
                    <>
                        <CustomButton
                            variant="outlined"
                            label="Cancel"
                            onClick={onHandleClose}
                        />
                        <CustomButton
                            variant="contained"
                            label={isSubmitting ? "Saving..." : title}
                            type="submit"
                            disabled={isSubmitting}
                            loading={isSubmitting}
                            onClick={handleSubmit}
                        />
                    </>
                }
            >
                <div className="row">
                    {visibleFields?.map((f, i) => (
                        <div
                            className={`${f.type === "checkbox"
                                ? "col-12 d-flex align-items-center mt-2"
                                : "col-12 col-md-6"
                                }`}
                            key={i}
                        >
                            {/* // <div className="col-12 col-md-6" key={i}> */}
                            {f?.type === "select" ? (
                                <SelectField
                                    label={f?.label}
                                    name={f?.name}
                                    value={formData[f?.name] || ""}
                                    onChange={handleChange}
                                    required
                                    options={f?.options}
                                    error={formErrors?.[f?.name]}
                                />
                            ) : f?.type === "checkbox" ? (
                                <FormCheckbox
                                    label={f?.label}
                                    name={f?.name}
                                    checked={formData[f?.name]}
                                    onChange={handleChange}
                                />
                            ) : (
                                <FormField
                                    label={f?.label}
                                    name={f?.name}
                                    type={f?.type}
                                    value={formData[f?.name] || ""}
                                    onChange={handleChange}
                                    onKeyDown={handleKeyDown}
                                    placeholder={`Enter ${f?.label}`}
                                    required
                                    error={formErrors?.[f?.name]}
                                />
                            )}
                        </div>
                    ))}
                </div>
            </CustomDialog>
        </>
    );
}




// import CustomDialog from "../../common/CustomDialog";
// import FormField from "../../common/FormField";
// import CustomButton from "../../common/CustomButton";
// import SelectField from "../../common/SelectField";
// import FormCheckbox from "../../common/FormCheckbox";

// export default function AddMerchantGroup({
//     open,
//     onHandleClose,
//     formData,
//     handleChange,
//     handleSubmit,
//     isSubmitting,
//     formErrors,
//     isEditing
// }) {
//     const fields = [
//         { label: "Group Name", name: "groupName", type: "text" },
//         { label: "Group Chat ID", name: "groupChatId", type: "text" },
//         {
//             label: "Group Type",
//             name: "groupType",
//             type: "select",
//             options: [
//                 { value: "payin", label: "Pay In" },
//                 { value: "payout", label: "Pay Out" },
//                 { value: "payin,payout", label: "Both" }
//             ]
//         },
//         { label: "Company Name", name: "companyName", type: "text" },
//         { label: "Merchant MID", name: "mid", type: "text" },
//         { label: "Created By", name: "createdBy", type: "text" },
//         { label: "Active Group", name: "isActive", type: "checkbox" },
//     ];

//     // Handles pressing Enter to submit from any field
//     const handleKeyDown = (e) => {
//         try {
//             if (e?.key === "Enter" && e?.target?.type !== "textarea") {
//                 e?.preventDefault();
//                 handleSubmit(e);
//             }
//         } catch (error) {
//             console.log(`Error: ${error}`);
//         }
//     };

//     const title = isEditing ? "Edit Merchant Group" : "Add Merchant Group";
//     const visibleFields = isEditing
//         ? fields.filter(f => !["mid", "createdBy"].includes(f.name))
//         : fields;

//     return (
//         <>
//             <CustomDialog
//                 open={open}
//                 onClose={onHandleClose}
//                 title={title}
//                 actions={
//                     <>
//                         <CustomButton
//                             variant="outlined"
//                             label="Cancel"
//                             onClick={onHandleClose}
//                         />
//                         <CustomButton
//                             variant="contained"
//                             label={isSubmitting ? "Saving..." : title}
//                             type="submit"
//                             disabled={isSubmitting}
//                             loading={isSubmitting}
//                             onClick={handleSubmit}
//                         />
//                     </>
//                 }
//             >
//                 <div className="row">
//                     {visibleFields?.map((f, i) => (
//                         <div
//                             className={`${f.type === "checkbox"
//                                 ? "col-12 d-flex align-items-center mt-2"
//                                 : "col-12 col-md-6"
//                                 }`}
//                             key={i}
//                         >
//                             {/* // <div className="col-12 col-md-6" key={i}> */}
//                             {f?.type === "select" ? (
//                                 <SelectField
//                                     label={f?.label}
//                                     name={f?.name}
//                                     value={formData[f?.name] || ""}
//                                     onChange={handleChange}
//                                     required
//                                     options={f?.options}
//                                     error={formErrors?.[f?.name]}
//                                 />
//                             ) : f?.type === "checkbox" ? (
//                                 <FormCheckbox
//                                     label={f?.label}
//                                     name={f?.name}
//                                     checked={formData[f?.name]}
//                                     onChange={handleChange}
//                                 />
//                             ) : (
//                                 <FormField
//                                     label={f?.label}
//                                     name={f?.name}
//                                     type={f?.type}
//                                     value={formData[f?.name] || ""}
//                                     onChange={handleChange}
//                                     onKeyDown={handleKeyDown}
//                                     placeholder={`Enter ${f?.label}`}
//                                     required
//                                     error={formErrors?.[f?.name]}
//                                 />
//                             )}
//                         </div>
//                     ))}
//                 </div>
//             </CustomDialog>
//         </>
//     );
// }